export function isValidImgixSource(image: string): boolean {
  return (
    (image.startsWith('http://') || image.startsWith('https://')) &&
    !image.startsWith('http://localhost') &&
    !image.includes('images.ctfassets.net') // Contentful
  );
}
